<template>
  <div style="background: #fff; padding: 16px">
    <!-- <Tabs
      v-model="tabsValue"
      @on-click="handleTapChange"
      style="margin-top: 20px"
    >
      <TabPane
        v-for="(item, index) in shareCPList2"
        :label="item.name"
        :name="item.name"
        :key="index"
      ></TabPane>
    </Tabs> -->
    <el-form :inline="true" :model="formFuzzy">
      <el-form-item label="内容提供商名称：">
        <el-input
          v-model="formFuzzy.namer"
          placeholder="请输入提供商名称"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onQuery" icon="el-icon-search"
          >搜索</el-button
        >
      </el-form-item>
    </el-form>

    <el-table
      ref="multipleTable"
      :data="queryData"
      :header-cell-style="rowClass"
      tooltip-effect="dark"
      style="width: 100%; font-size: 12px"
      @selection-change="handleSelectionChange"
      @sort-change="tableSortChg"
      v-loading.body="loading"
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column
        prop="id"
        label="ID"
        align="center"
        width="110"
        sortable="custom"
      ></el-table-column>
      <!-- <el-table-column
        prop="name"
        label="图书名称"
        align="center"
        min-width="240"
        sortable="custom"
      >
        <template slot-scope="scope">
          <a
            href="javascript:;"
            @click="viewHowEdit(scope.row)"
            style="color: #1d90e6; font-size: 13px"
            >{{ scope.row.name }}</a
          >
        </template>
      </el-table-column> -->
      <el-table-column
        prop="name"
        label="内容提供商"
        align="center"
        min-width="120"
      ></el-table-column>
      <el-table-column prop="logo" label="封面" align="center" min-width="120">
        <template slot-scope="scope">
          <img :src="scope.row.logo" min-width="70" height="70" />
        </template>
      </el-table-column>
      <el-table-column
        prop="updated_at"
        label="更新时间"
        align="center"
        width="180"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.updated_at | formatDate2 }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="clevel"
        label="当前状态"
        width="120"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.clevel == 0" type="danger">已下架</el-tag>
          <el-tag v-else-if="scope.row.clevel == 4" type="gray"
            >审核通过</el-tag
          >
          <el-tag v-else-if="scope.row.clevel == 5" type="success"
            >已上架</el-tag
          >
          <el-tag v-else-if="scope.row.clevel == 2" type="primary"
            >编辑中</el-tag
          >
        </template>
      </el-table-column> -->
      <!-- <el-table-column
        prop="updated_at"
        label="更新时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.updated_at | formatDate2 }}</span>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="editor"
        label="编辑账号"
        width="110"
        align="center"
      ></el-table-column>

      <el-table-column
        label="操作"
        show-overflow-tooltip
        align="center"
        width="100"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="管理内容"
            placement="top"
          >
            <el-button
              type="info"
              size="mini"
              icon="el-icon-folder"
              circle
              @click="bookInfo(scope.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <!-- <el-button
      type="primary"
      @click="borrowBook"
      icon="el-icon-copy-document"
      style="margin-top: 10px"
      >领取</el-button
    > -->
    <!-- <div class="pagination-box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="queryParams.page"
        :page-sizes="[20, 50, 100]"
        :page-size="queryParams.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal"
      ></el-pagination> -->
    <!-- </div> -->
  </div>
</template>

<script>
import { ApiMessage, formatDate } from "@/utils/util";
import { deepObjectCopy } from "@/utils/tools";
export default {
  name: "receiveBook",
  data() {
    return {
      shareCPList: [],
      shareCPList2: [],
      allshareCPList: [],
      queryData: [],
      queryNewData: [],
      queryOldData: [],
      queryeverData: [],
      formFuzzy: {
        bookId: "",
        bookName: "",
        bookBrand: "",
        state: "",
        cpId: "",
        bookLevel: "",
      },
      queryParams: {
        page: 1,
        pageSize: 20,
      },
      pageTotal: 0,
      multipleSelection: [],
      order: "id,desc", //"name,asc",
      loading: true,
      currCPID: this.editCPId, //null,
      tabsValue: "",
    };
  },
  components: {},
  props: {},
  created() {
    // debugger
    this.initCplist();
  },
  computed: {},
  filters: {
    formatDate2(d) {
      return formatDate(d, "yyyy-MM-dd hh:mm:ss");
    },
  },
  mounted() {},
  watch: {},
  methods: {
    bookInfo(cp) {
      console.log(cp, "cp======");
      this.$emit("gotoBook", { name: cp.name, id: cp.id });
    },
    rowClass() {
      return "background:#f9f9f9;color:#000000;font-size:14px;height:22px";
    },
    fetchQueryData() {
      return new Promise((resolve,r)=>{
        console.log(111);
      let params;
      let cpid = [];
      //cpid.push(Number(this.$route.query.cpid));
      cpid.push(this.formFuzzy.cpId);
      params = {
        appId: this.$API.APPID,
        dbId: cpid,
        sort: this.order,
        onlyAuthorised: 1,
        dtype: 1,
      };
      if (this.formFuzzy.bookId != "") {
        let bookid = [];
        bookid.push(Number(this.formFuzzy.bookId));
        params.id = bookid;
      }
      if (this.formFuzzy.bookName != "") {
        params.name = this.formFuzzy.bookName;
      }
      if (this.formFuzzy.bookBrand != "") {
        let brandId = [];
        brandId.push(Number(this.formFuzzy.bookBrand));
        params.tagIds = brandId;
      }
      if (this.formFuzzy.state !== "") {
        params.clevel = Number(this.formFuzzy.state);
      }
      let cpidList = [];
      if (this.formFuzzy.cpId != "") {
        cpidList.push(Number(this.formFuzzy.cpId));
      } else {
        // debugger
        this.allAllCp(cpidList);
        // debugger;
      }
      if (cpidList.length == 0) {
        // debugger
        this.loading = false;
        return;
      } else {
        params.dbId = cpidList;
        if (this.formFuzzy.bookLevel != "") {
          params.keywords = this.formFuzzy.bookLevel;
        }
        params.type = 10;
        params.pageSize = this.queryParams.pageSize;
        params.page = this.queryParams.page;
        // debugger
        this.$axios
          .post("/aries-api/resourceDb/list", params)
          .then((response) => {
            // debugger
            console.log(response);
            if (response.data.result == 0) {
              this.queryData = response.data.data.share;
              console.log(this.queryData, "this.queryData========");
              this.loading = false;
            } else {
              this.loading = false;

              alert(response.data.msg);
            }
            resolve()
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
          });
      }
      })
    },
    tableSortChg(val) {
      // console.log(5555);
      if (val.order == "descending") {
        this.order = val.prop + ",desc";
      } else if (val.order == "ascending") {
        this.order = val.prop + ",asc";
      }
      this.fetchQueryData();
    },
    allAllCp(cpid) {
      console.log(this.shareCPList);
      for (let i = 0; i < this.shareCPList.length; ++i) {
        cpid.push(this.shareCPList[i].id);
        // debugger
      }
    },
   async onQuery() {
     await this.fetchQueryData()

                 if(!this.queryData){
              return
            }
      // this.queryParams.page = 1;
      var _this = this;
      var queryeverData = [];
      if (this.formFuzzy.namer != "") {
        this.queryData.map(function (item) {
          if (item.name.search(_this.formFuzzy.namer) != -1) {
            queryeverData.push(item);
          }
        });
        console.log(queryeverData, "queryData查找到的数据========");
        this.queryData = queryeverData;
      }else{
        this.fetchQueryData()
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    viewHowEdit(book) {
      this.$router.push({
        name: "addbook",
        query: {
          cpid: book.dbId,
          bookid: book.id,
          do: "view",
        },
      });
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.fetchQueryData();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.fetchQueryData();
    },
    initCplist() {
      console.log(555);
      let params = {
        appId: this.$API.APPID,
        //otype: 2,
        dtype: 1,
        onlyAuthorised: 1,
        needAppName: 1,
      };
      this.$axios
        .post("/aries-api/resourceDb/list", params)
        .then((response) => {
          console.log(response);
          if (response.data.result == 0) {
            if (response.data.data.share != "undefined") {
              this.allshareCPList = response.data.data.share;
              this.setCPList();
              // console.log(this.allshareCPList, "huixianshuju");
            } else {
              this.allshareCPList = [];
              // this.setCPList();
            }
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
    setCPList() {
      console.log(222);

      // if (sessionStorage.getItem("cpShareList") != "undefined") {
      // this.shareCPList = JSON.parse(sessionStorage.getItem("cpShareList"));
      if (this.allshareCPList) {
        this.shareCPList = this.allshareCPList;
      }

      // console.log(this.shareCPList, "我要的数据");
      // }
      this.setCPlist2();
    },
    setCPlist2() {
      console.log(3333);

      let temp = { name: "全部" };
      this.shareCPList2 = deepObjectCopy(this.shareCPList);
      this.shareCPList2.splice(0, 0, temp);
      this.currCPID = null;
      this.tabsValue = this.shareCPList2[0].name;
      this.fetchQueryData();
    },
    handleTapChange(tabName) {
      console.log(444);

      if (tabName == "全部") {
        this.currCPID = null;
        this.formFuzzy.cpId = "";
      } else {
        for (let i = 0; i < this.shareCPList.length; ++i) {
          if (this.tabsValue == this.shareCPList[i].name) {
            this.currCPID = this.shareCPList[i].id;
            this.formFuzzy.cpId = this.currCPID;
            break;
          }
        }
      }
      this.queryParams.pageSize = 20;
      this.queryParams.page = 1;
      this.fetchQueryData();
    },
    checkCopyCPId() {
      return new Promise((resolve, reject) => {
        let temp = JSON.parse(sessionStorage.getItem("cpList"));
        if (temp != null) {
          let foundCP = false;
          for (let i in temp) {
            if (temp[i].name == "自有图书库") {
              foundCP = true;
              resolve(temp[i].id);
            }
          }
          if (!foundCP) {
            let params = {
              appId: this.$API.APPID,
              dtype: 1, //选填，cp类型 0 音视频类| 1 书籍类
              name: "自有图书库", //必填
              logo: "", //选填
              is_open: 1, //必填
              otype: 2, //资源库类型，可选值 0系统库  1开发者库   2应用私有库， 选填
              id: 0,
            };
            this.$axios
              .post("/aries-api/resourceDb/save", params)
              .then((response) => {
                console.log(response);
                if (response.data.result == "0") {
                  resolve(response.data.data.id);
                } else {
                  reject(null);
                }
              })
              .catch((error) => {
                ApiMessage(this, error.toString(), "error");
                reject(null);
              });
          }
        }
      });
    },
    borrowBook() {
      if (this.multipleSelection.length == 0) {
        alert("请先选择书籍");
        return;
      }
      this.checkCopyCPId().then((res) => {
        if (res != null) {
          let dbId = res;
          let len = this.multipleSelection.length;
          let opNum = 0;
          for (let i = 0; i < len; ++i) {
            let params = {
              appId: this.$API.APPID,
              id: this.multipleSelection[i].id,
              dbId: this.multipleSelection[i].dbId,
            };
            this.$axios
              .post("/aries-api/resource/get", params)
              .then((response) => {
                console.log(response);
                let m = response.data;
                if (m.result == 0) {
                  let temp = m.data;
                  temp.appId = this.$API.APPID;
                  temp.src_id = temp.id;
                  temp.id = 0;
                  temp.dbId = dbId;
                  temp.clevel = 2;
                  delete temp.created_at;
                  delete temp.updated_at;

                  this.copySave(temp).then((res2) => {
                    if (res2 != null) {
                      opNum += 1;
                      this.checkOver(opNum);
                    } else {
                      return;
                    }
                  });
                } else {
                  alert(response.data.msg);
                }
              })
              .catch((error) => {
                ApiMessage(this, error.toString(), "error");
              });
          }
        }
      });
    },
    copySave(temp) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post("/aries-api/resource/save", temp)
          .then((response) => {
            console.log(response);
            if (response.data.result == "0") {
              resolve(response.data.data.id);
            } else {
              alert(response.data.msg);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
    checkOver(num) {
      if (num == this.multipleSelection.length) {
        this.$Message.success("操作成功!");
        this.fetchQueryData();
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../fyd-style.less";
.pagination-box {
  padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// publishBook.vue?27726ccb